export default "__VITE_PUBLIC_ASSET__65b43712__"